import Backbone from 'backbone';

import { location, setLocation } from 'utils/wrappers';
import Session from 'app/models/session';

import Base from 'app/views/base';
import tmpl from 'templates/navbar';

const EasyPost = global.EasyPost;

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #signout': 'signOut',
    'click a[href="/signin"]': 'navigate',
    'click a[href="/signup"]': 'navigate',
  },

  initialize() {
    this.listenTo(this.model, 'sync', this.render);
  },

  context() {
    return {
      loggedIn: this.model.isLoggedIn(),
      email: this.model.get('email'),
      onDashboard: location().pathname.indexOf('/account') === 0,
    };
  },

  navigate(e) {
    e.preventDefault();
    Backbone.history.navigate($(e.target).attr('href'), true);
  },

  signOut(e) {
    e.preventDefault();
    new Session({ id: 'deleteme' }).destroy({
      success() {
        setLocation('/');
      },
      error() {
        EasyPost.Globals.currentUser.fetch({
          error() {
            setLocation('/');
          },
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/navbar_component.js